import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

export default function WaitlistVerify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("checking");
  useSEO("Verify Your Waitlist Spot | NAKSRA", "Verify your email address for the NAKSRA Retain-a-Guru waitlist.");

  useEffect(() => {
    if (!token) {
      setStatus("failed");
      return;
    }
    api
      .get("/waitlist/verify", { params: { token } })
      .then(() => setStatus("verified"))
      .catch(() => setStatus("failed"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050507] text-[#F8F9FA]">
      <Navbar />
      <main className="mx-auto max-w-2xl px-6 py-32 text-center" data-testid="waitlist-verify-page">
        {status === "checking" && <p className="text-[#A1A1AA]">Verifying your email…</p>}
        {status === "verified" && (
          <div data-testid="verify-success">
            <CheckCircle2 className="mx-auto h-12 w-12 text-[#17B890]" />
            <h1 className="mt-6 font-heading text-4xl font-medium tracking-tight">You're on the wait-list</h1>
            <p className="mt-6 leading-relaxed text-[#A1A1AA]">
              Your email is verified and your spot is confirmed. You'll be among the first to know when Retain a Guru goes live — with free gifts and the best discounts reserved for early members.
            </p>
            <Link to="/" data-testid="verify-home-cta" className="mt-10 inline-block rounded-full bg-[#D4AF37] px-8 py-3 text-sm font-semibold text-black transition-colors duration-300 hover:bg-[#FBE18D] active:scale-[0.98]">
              Back to NAKSRA
            </Link>
          </div>
        )}
        {status === "failed" && (
          <div data-testid="verify-failed">
            <XCircle className="mx-auto h-12 w-12 text-red-400" />
            <h1 className="mt-6 font-heading text-4xl font-medium">This link is invalid or expired</h1>
            <p className="mt-6 leading-relaxed text-[#A1A1AA]">Please join the wait-list again to receive a fresh verification link.</p>
            <Link to="/retain-a-guru" data-testid="verify-retry-cta" className="mt-10 inline-block rounded-full bg-[#D4AF37] px-8 py-3 text-sm font-semibold text-black transition-colors duration-300 hover:bg-[#FBE18D] active:scale-[0.98]">
              Join the wait-list
            </Link>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
